import { DataCellProps } from '../types';

export const TenantArchiverCell = ({ _customRowProps, tenant }: DataCellProps) => {
  return <div>{tenant.archiver}</div>;
};
